export const matchUrl = (patterns: string[], url: string) =>
  patterns.some((pattern) => {
    const regexPattern = pattern.replace(/\*/g, '.*');
    const regex = new RegExp(`^${regexPattern}$`);
    return regex.test(url);
  });
